/**
 * Generates a SHA-256 hash of a push notification endpoint.
 * This must match the backend implementation in packages/api/src/push-notifications/shared/endpoint-row-key.ts
 */
export async function endpointToHash(endpoint: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(endpoint);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
